import { Canceler } from "axios";
import { EntityApi } from "../../services/ApiPlatform";
import { PrimitiveObject } from "../../services/ApiPlatform/types";
import { FinalResponse, ListResponse } from "../../services/ApiPlatform/models";

export abstract class SchoolApi extends EntityApi {
    protected static GET_COLLECTION = "/api/schools";

    protected static POST_COLLECTION = "/api/schools";

    protected static GET_ITEM = "/api/schools/{id}";

    protected static PUT_ITEM = "/api/schools/{id}";

    protected static PATCH_ITEM = "/api/schools/{id}";

    protected static DELETE_ITEM = "/api/schools/{id}";

    protected static GET_COLLECTION_MY_SCHOOLS = "/api/schools/my";

    protected static GET_COLLECTION_MY_PARTNERSHIP =
        "/api/schools/my-partnership";

    public static async getCollectionMySchools<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_MY_SCHOOLS,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }

    public static async getCollectionMyPartnership<R>(
        page = 1,
        extraParams: PrimitiveObject = {},
        cancelToken?: (c: Canceler) => void
    ): Promise<FinalResponse<ListResponse<R> | null>> {
        extraParams = {
            ...extraParams,
            PATH: this.GET_COLLECTION_MY_PARTNERSHIP,
        };
        return this.getCollection(page, extraParams, cancelToken);
    }
}
